import { ApiError } from '@/shared/api/client.ts'
import { Button } from '@/shared/ui/button.tsx'
import { Alert } from '@/shared/ui/states.tsx'
import { StaffDialog } from './staff-dialog.tsx'

interface ConfirmStaffDialogProps {
  title: string
  description: string
  confirmLabel: string
  pending: boolean
  error: unknown
  onConfirm: () => void
  onClose: () => void
}

export function ConfirmStaffDialog({
  title,
  description,
  confirmLabel,
  pending,
  error,
  onConfirm,
  onClose,
}: ConfirmStaffDialogProps) {
  const message = error ? (error instanceof ApiError ? error.message : 'Не получилось — попробуйте ещё раз.') : null

  return (
    <StaffDialog titleId="confirm-staff-title" busy={pending} onClose={onClose}>
      {(close) => (
        <div className="flex flex-col gap-4 px-6 py-5.5">
          <div className="flex flex-col gap-1.5">
            <h2 id="confirm-staff-title" className="font-display text-[19px] font-semibold tracking-[-0.01em]">
              {title}
            </h2>
            <p className="text-[14px] text-ink-muted text-balance-pretty">{description}</p>
          </div>
          {message && <Alert>{message}</Alert>}
          <div className="flex flex-wrap justify-end gap-2">
            <Button variant="secondary" size="sm" disabled={pending} onClick={close}>
              Отмена
            </Button>
            <Button size="sm" loading={pending} onClick={onConfirm}>
              {confirmLabel}
            </Button>
          </div>
        </div>
      )}
    </StaffDialog>
  )
}
